import React from 'react';

import { StepProps } from '@betterment/js-runtime';
import { Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { Box, Button, Heading } from '@betterment/style-closet-react';

import { CustomerSignupValues } from './Controller';

import { User } from '../Checking/data';
import { WorkflowLayout } from '../Shared/layout/WorkflowLayout';
import { urlBuilder } from '../Shared/urlBuilder';

interface Props extends StepProps<CustomerSignupValues> {
  user: User;
  handleClose: () => void;
}

const FundAccount: React.FC<React.PropsWithChildren<Props>> = ({ flowState, handleClose }) => {
  const { stepTitle } = flowState.values;
  return (
    <WorkflowLayout pageTitle="Sign up - Checking" workflowTitle={stepTitle} onClose={handleClose}>
      <Box mb="6">
        <Icon name="CheckmarkCircle" size="large" color="icon.success" />
      </Box>
      <Heading variant="primary">Your Checking account has been created</Heading>
      <Box pb="6" pt="3">
        <Text as="p" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
          Keep an eye out for your Betterment Visa&reg; Debit Card, which should arrive in 6-8 business days.
        </Text>
        <Text
          as="p"
          css={{
            marginBottom: 'space.0',
          }}
        >
          We suggest funding your account so that your card is ready to use once it arrives.
        </Text>
      </Box>
      <SambaAutoLink
        to={urlBuilder.getCheckingFundingOptions.absolute({ accountId: flowState.values.customer?.account.id ?? 0 })}
      >
        <Button type="button" px="8">
          Fund your account
        </Button>
      </SambaAutoLink>
    </WorkflowLayout>
  );
};

export default FundAccount;
